import { all } from "redux-saga/effects";
import userSaga from "./user-saga";
import caseSaga from "./case-saga";
import caseDetailSaga from "./case-detail-saga";
import companySaga from "./company-saga";
import stageSaga from "./stage-saga";
import stageCaseSaga from "./stage-case-saga";
import caseCountSaga from "./case-count-saga";
import companySupplyChainSaga from "./company-supply-chain-saga";
import questionareSaga from "./questionare-saga";
import documentsSaga from "./documents-saga";
import statementSaga from "./statement-saga";
import scoreCardSaga from "./scorecard-saga";
import financialsSaga from "./financials-saga";
import caseCreateSaga from "./case-create-saga";
import caseNoteSaga from "./case-note-saga";
import payProCaseNoteSaga from "./paypro-case-note-saga";
import bucketCaseSaga from "./bucket-case-saga";
import schemeSaga from "./schemes-saga";
import MarketDataSaga from "./market-data-saga";
import RegionSaga from "./region-saga";
import CaseMetaSaga from "./case-meta-saga";
import facilityAccountSaga from "./facility-account-saga";
import accountViewSaga from "./account-view-saga";
import companyLosProfileSaga from "./../../modules/companies/sagas/company-profile-saga";
import invoiceJobSaga from "./../../modules/companies/sagas/invoice-job-saga";
import decisioningDashboardSaga from "./../../modules/decision-dashboard/sagas";
import bankStatementAnalyserSaga from "./bank-statement-analyser-saga";
import applicantVerificationSaga from "./applicant-verification-saga";
import bankAccountSaga from "./../../modules/virtual-accounts/sagas/bank-accounts";
import lenderAccountSaga from "./../../modules/virtual-accounts/sagas/lender-account";
import cibilSaga from "./cibil-saga";
import PaymentProgramSaga from "./payment-program-saga";
import DBOnBoadingSaga from './db-onboarding-saga';
import OnboardingSaga from "./onboarding-saga";
import RetailerRiskControlSaga from "./retailer-risk-control-saga";
// import caseModuleSaga from "modules/cases/sagas";
export default function* () {
    yield all([
        userSaga,
        caseCountSaga,
        caseSaga,
        companySaga,
        caseDetailSaga,
        stageCaseSaga,
        stageSaga,
        companySupplyChainSaga,
        questionareSaga,
        documentsSaga,
        statementSaga,
        scoreCardSaga,
        financialsSaga,
        caseCreateSaga,
        caseNoteSaga,
        bucketCaseSaga,
        schemeSaga,
        MarketDataSaga,
        RegionSaga,
        CaseMetaSaga,
        facilityAccountSaga,
        companyLosProfileSaga,
        invoiceJobSaga,
        accountViewSaga,
        decisioningDashboardSaga,
        bankStatementAnalyserSaga,
        applicantVerificationSaga,
        bankAccountSaga,
        lenderAccountSaga,
        cibilSaga,
        PaymentProgramSaga,
        payProCaseNoteSaga,
        DBOnBoadingSaga,
        OnboardingSaga,
        RetailerRiskControlSaga
        // caseModuleSaga
    ]);
}
